import React from 'react'

function Footer() {
  return (
    <footer>
      This is Footer
    </footer>
  )
}

export default Footer